import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-faculty-card',
  templateUrl: './faculty-card.component.html',
  styleUrls: ['./faculty-card.component.scss']
})
export class FacultyCardComponent implements OnInit {
  @Input() data:any;
  constructor() { }

  ngOnInit(): void {
  }

}
